import { useQuery } from "@tanstack/react-query";
import { getCartsCount } from "src/api/cart";
export const useCartCountsQuery = (param)=>{
    let { enabled  } = param;
    return useQuery([
        "cartCounts"
    ], getCartsCount, {
        enabled,
        select: (data)=>data.cartCounts.reduce((acc, cur)=>({
                    ...acc,
                    [cur.cartType]: cur.itemCount
                }), {
                separate: 0,
                pod: 0,
                delivery: 0,
                ebook: 0,
                total: data.totalCount
            })
    });
};
